// extracted by mini-css-extract-plugin
export default {"button-box":"ActivateAccount_button-box__XGlMX","input-box":"ActivateAccount_input-box__6WkGR","window":"ActivateAccount_window__NE-rI"};